'use strict';

import jQuery from 'jquery';
import slick from './../../../vendor/jquery.slick.1.8.0.min';
import Core from './../../Core/Core';

var WatchNowPage = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    privateNS.init = function init() {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Create a reference to the most popular shows
      privateNS.$mostPopular = privateNS.$container.find('.show-list-featured-wrapper .featured-list');

      // Initialize the slideshow on page load
      privateNS.initializeSlickSlideshow(privateNS.$mostPopular);

      Core.blocks.Drawer({
        container: '.recently-added'
      });

      // Add event handlers to the UI controls
      privateNS.attachHandlers();

      // Return the public namespace
      return publicNS;
    };

    /**
     * Initializes the slick slider as a method of controlling the horizontally
     * scrolling popular shows
     *
     * @param {jQuery} $slides The container that holds the slideshow elements
     */
    privateNS.initializeSlickSlideshow = function createSlickSlideshow($slides) {

      // Initialize the slick slideshow settings on the slide container
      $slides.slick({
        // xxlarge
        infinite: true,
        nextArrow: '.show-list-scroll-right',
        prevArrow: '.show-list-scroll-left',
        slidesToScroll: 6,
        slidesToShow: 7,
        useCSS: true,
        responsive: [
          { // xlarge
            breakpoint: 1200,
            settings: {
              slidesToScroll: 4,
              slidesToShow: 5
            }
          },
          { // large
            breakpoint: 768,
            settings: {
              slidesToScroll: 3,
              slidesToShow: 4
            }
          },
          { // small + medium
            breakpoint: 640,
            settings: 'unslick'
          }
        ]
      });
    };

    /**
     * Reinitializes the slick slider on the most popular shows if the slider
     * has been destroyed. This will only occur at large enough window sizes
     */
    privateNS.reinitializeSlick = function reinitializeSlick() {

      // Make sure the window is large enough to display the slider
      if ($(window).width() > 640) {

        // Get the slideshow plugin object from the slide element
        var slickSettings = privateNS.$mostPopular.slick('getSlick');

        // If slideshow was never initialize, or it was destroyed, reinitialize it
        if (typeof slickSettings === 'undefined' || slickSettings.unslicked) {
          privateNS.initializeSlickSlideshow(privateNS.$mostPopular);
        }
      }
    };

    /**
     * Binds the initialize event handlers for the page
     */
    privateNS.attachHandlers = function attachHandlers() {

      $(window).on(
        'resize',
        Core.utils.debounce(
          privateNS.reinitializeSlick,
          500
        )
      );
    };

    return privateNS.init();
  };
})(jQuery);

export default WatchNowPage